<template>
  <div>
    <c-search-box @enter="getDataList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <c-select :editable="editable" :comboItems="useFlagItems" label="LBLUSEFLAG" itemText="codeName" itemValue="code" name="useFlag" type="search" v-model="searchParam.useFlag"> </c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
        <c-table ref="table" title="검사항목 목록" tableId="table" :columns="grid.columns" :gridHeight="grid.height" :data="grid.data" :columnSetting="false" @rowClick="rowClick">
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline>
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getDataList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <q-form ref="editForm">
          <c-card title="LBLDETAIL" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline>
                <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="addData" />
                <c-btn v-if="editable && saveable" :url="saveUrl" :isSubmit="isSave" :param="data" :mappingType="saveType" label="LBLSAVE" icon="save" @beforeAction="saveData" @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <c-plant :required="true" :editable="editable && !updateMode" type="edit" name="plantCd" v-model="data.plantCd" />
              </div>
              <div class="col-6">
                <c-text :editable="editable && dataeditable" :required="true" label="검사항목명" name="envWaterMstInspectItemName" v-model="data.envWaterMstInspectItemName"> </c-text>
              </div>
              <div class="col-6">
                <c-text :editable="editable && dataeditable" :required="true" label="법적기준" name="legalStandard" type="text" v-model="data.legalStandard"> </c-text>
              </div>
              <div class="col-6">
                <c-text :editable="editable && dataeditable" :required="true" label="내부기준" name="innerStandard" type="text" v-model="data.innerStandard"> </c-text>
              </div>
              <div class="col-6">
                <c-checkbox :editable="editable && dataeditable" :isFlag="true" label="LBLUSEFLAG" name="useFlag" v-model="data.useFlag" />
              </div>
              <div class="col-6">
                <c-text :editable="editable && dataeditable" :required="true" label="순번" type="number" name="sortOrder" v-model="data.sortOrder"> </c-text>
              </div>
              <div class="col-6">
                <c-select
                  :editable="editable && dataeditable"
                  codeGroupCd="AIR_INSPECT_UNIT_CD"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="unitCd"
                  label="단위"
                  v-model="data.unitCd"
                />
              </div>
            </template>
          </c-card>
        </q-form>
      </div>
    </div>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'water-master-04',
  props: {
    param: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      data: {
        plantCd: null,
        envWaterMstInspectItemId: '', // 대기 검사항목 일련번호
        envWaterMstInspectItemName: '', // 대기 검사항목명
        legalStandard: '', // 법적기준
        innerStandard: '', // 내부기준
        useFlag: 'Y', // 사용여부
        sortOrder: '',
      },
      searchParam: {
        useFlag: 'Y',
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width: 100px',
            sortable: true,
          },
          {
            name: 'envWaterMstInspectItemName',
            field: 'envWaterMstInspectItemName',
            label: '검사항목',
            align: 'left',
            sortable: true,
          },
          {
            name: 'unitName',
            field: 'unitName',
            label: '단위',
            align: 'center',
            style: 'width: 60px',
            sortable: true,
          },
          {
            name: 'legalStandard',
            field: 'legalStandard',
            label: '법적기준',
            align: 'center',
            type: 'cost',
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: 'innerStandard',
            field: 'innerStandard',
            label: '내부기준',
            align: 'center',
            type: 'cost',
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: '순번',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      detailUrl: '',
      insertUrl: '',
      updateUrl: '',
      saveable: false,
      dataeditable: false,
      updateMode: false,
      isSave: false,
      saveUrl: transactionConfig.env.water.mst.inspect.save.url,
      saveType: 'POST',
    };
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.dataeditable = false;
      // api scope
      this.listUrl = selectConfig.env.water.mst.inspect.list.url;
      this.detailUrl = selectConfig.env.water.mst.inspect.get.url;
      this.insertUrl = transactionConfig.env.water.mst.inspect.save.url;
      this.updateUrl = transactionConfig.env.water.mst.inspect.save.url;
      this.getDataList();
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1')[0];
      if (_table) {
        _table.classList.remove('bg-light-blue-1');
      }
    },
    getDataList() {
      this.getList();
      this.rowRemoveSelect();
      this.reset();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request(_result => {
        this.grid.data = _result.data;
      });
      this.saveable = false;
    },
    rowClick(row) {
      // 상세조회
      this.saveable = true;
      this.updateMode = true;
      this.$http.url = this.detailUrl;
      this.$http.param = {
        envWaterMstInspectItemId: row.envWaterMstInspectItemId,
      };
      this.$http.type = 'GET';
      this.$http.request(
        _result => {
          this.data = _result.data;
          this.saveUrl = this.updateUrl;
          this.saveType = 'PUT';
          this.dataeditable = true;
        },
        () => {}
      );
    },
    addData() {
      this.saveable = true;
      this.saveUrl = this.insertUrl;
      this.saveType = 'POST';
      this.updateMode = false;
      this.dataeditable = true;
      this.data = {
        plantCd: this.$store.getters.user.plantCd,
        envWaterMstInspectItemId: '', // 대기 검사항목 일련번호
        envWaterMstInspectItemName: '', // 대기 검사항목명
        legalStandard: '', // 법적기준
        innerStandard: '', // 내부기준
        useFlag: 'Y', // 사용여부
        sortOrder: '',
      };
      this.rowRemoveSelect();
    },
    reset() {
      this.rowRemoveSelect();
      this.saveable = false;
      this.updateMode = false;
      this.dataeditable = false;
      this.data = {
        plantCd: this.$store.getters.user.plantCd,
        envWaterMstInspectItemId: '', // 대기 검사항목 일련번호
        envWaterMstInspectItemName: '', // 대기 검사항목명
        legalStandard: '', // 법적기준
        innerStandard: '', // 내부기준
        useFlag: 'Y', // 사용여부
        sortOrder: '',
      };
    },
    saveData() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDataList();
    },
  },
};
</script>
